import React, { useEffect, useState } from "react";
import LinksMeticCard from "./Sub/LinksMeticCard";
import StatusMeticCard from "./Sub/StatusMeticCard";
import ClicksMeticCard from "./Sub/ClicksMetricCard";
import axios from "../../../api/axios";
import { DASHBOARD_METRICS_URL } from "../../../constants/ApiUrls";

function Metrics({ auth }) {
  useEffect(() => {
    getmetrics();
  });
  const [metrics, setMetrics] = useState({
    totalClicks: 0,
    totalLinks: 0,
    totalActiveLinks: 0,
  });
  const getmetrics = async (e) => {
    try {
      const response = await axios.get(DASHBOARD_METRICS_URL, {
        params: { userId: auth.userId },
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });
      setMetrics(() => response.data);
    } catch (err) {}
  };
  return (
    <div className="flex w-full justify-between md:gap-32px gap-16px overflow-x-auto pb-16px select-none">
      <LinksMeticCard totalLinks={metrics.totalLinks} />
      <StatusMeticCard totalActiveLinks={metrics.totalActiveLinks} />
      <ClicksMeticCard totalClicks={metrics.totalClicks} />
    </div>
  );
}

export default Metrics;
